<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            COMPLIANCE / Taxation / Withholding Tax
            <div class="settings-header__btn">
              <el-select v-model="taxType" @change="changeType" size="small" placeholder="Select">
                <el-option
                  v-for="item in taxTypeList"
                  :disabled="item.isDisabled"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

          <el-tabs v-model="activeTabWTMInternal" @tab-click="handleClick">
            <el-tab-pane label="Tax Accounts" name="wTaxLibrary">
              <wTaxLibrary ref="wTaxLibrary"/>
            </el-tab-pane>
            <!-- <el-tab-pane label="GL (Tax Accounts)" name="wTaxAccountResult">
              <w-tax-account-result ref="wTaxAccountResult" />
            </el-tab-pane> -->
            <el-tab-pane label="Tax Management" name="taxManagement">
              <tax-management ref="taxManagement"/>
            </el-tab-pane>
            <el-tab-pane label="Tax Reporting" name="expanded">
              <expanded ref="expanded"/>
            </el-tab-pane>
            <el-tab-pane label="BIR Certificates" name="fifth">{{msg}}</el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wTaxLibrary from '@/components/taxation/withholdingTaxPortal/wTaxLibrary.vue'
import WTaxAccountResult from "../components/taxation/withholdingTaxPortal/wTaxAccountResult";
import TaxManagement from "../components/taxation/withholdingTaxPortal/TaxManagement";
import Expanded from "../components/taxation/withholdingTaxPortal/Expanded";
import axios from 'axios'
let moment = require('moment');
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: 'Taxation',
  components: {
    WTaxAccountResult,
    SweetModal,
    wTaxLibrary,
    TaxManagement,
    Expanded,
  },
  data() {
    return {
      tableData: [],
      activeTabWTMInternal: 'wTaxLibrary',
      msg: 'Sorry, this feature now under development will be ready later.',
      taxType: 'taxation-withholding',
      taxTypeList: [
        { id: 1, name: 'Sales Tax (Vatable)', isDisabled: false, value: 'taxation-sales' },
        { id: 2, name: 'Withholding Tax Expanded', isDisabled: true, value: 'taxation-withholding' },
        { id: 3, name: 'Income Tax', isDisabled: true, value: 'taxation-income' },
      ],
    }
  },
  mounted () {
    this.$refs['wTaxLibrary'].loadList()
  },
  methods: {
    changeType(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    handleClick(tab, event) {
      if (tab.name === 'third') {
        this.activeTabWTMInternal = 'wTaxLibrary'
        this.$refs['wTaxLibrary'].loadList()
      } else if (tab.name === 'wTaxAccountResult') {
        this.$refs['wTaxAccountResult'].loadList()
      } else if (tab.name === 'taxManagement') {
        this.$refs['taxManagement'].loadList()
      } else if (tab.name === 'expanded') {
        this.$refs['expanded'].loadList()
      }

      if (tab.name === 'wTaxLibrary'){
        this.$refs['wTaxLibrary'].loadList()
      }

    }
  },
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
